import { Link } from "react-router-dom";
import { ArrowRight, Plug } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageShell, PageHero } from "@/components/marketing/PageShell";
import { CONNECTORS } from "@/content/pages";

export default function Connectors() {
  const { groups, statusLabels } = CONNECTORS;
  return (
    <PageShell testid="connectors-root" seo={{
      title: "Connectors — Sema",
      description: "Connect Sema to Postgres, Snowflake, BigQuery, Redshift, Databricks and more. See supported and upcoming data sources.",
      keywords: "data connectors, postgres, snowflake, bigquery, redshift, databricks, warehouse integration",
      path: "/connectors",
    }}>
      <PageHero testid="connectors-h1" eyebrow="Connectors"
        title="Connect the warehouse you already have."
        subtitle="Sema introspects your schema directly — no pipeline rebuild. Here's what's supported today and what's on the way." />

      <section className="pb-24">
        <div className="mx-auto w-full max-w-5xl space-y-12 px-6">
          {groups.map((g) => (
            <div key={g.title}>
              <h2 className="font-mono text-[11px] uppercase tracking-[0.22em] text-muted-foreground">{g.title}</h2>
              <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
                {g.items.map((it) => {
                  const s = statusLabels[it.status];
                  return (
                    <div key={it.name} data-testid={`connector-${it.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                      className="flex items-center justify-between rounded-2xl border border-border/60 bg-card/50 px-5 py-4 backdrop-blur">
                      <span className="flex items-center gap-3">
                        <Plug className="h-4 w-4 text-muted-foreground" />
                        <span className="text-sm font-medium">{it.name}</span>
                      </span>
                      <span className="inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.14em]" style={{ color: s.color }}>
                        <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: s.color }} />{s.label}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}

          <div className="rounded-2xl border border-border/60 bg-card/40 p-8 text-center backdrop-blur">
            <h3 className="text-xl font-semibold tracking-tight">Need a connector we don't list yet?</h3>
            <p className="mx-auto mt-2 max-w-md text-sm text-muted-foreground">Tell us your stack — we prioritize connectors by customer demand.</p>
            <Link to="/contact" className="mt-5 inline-block">
              <Button className="rounded-full bg-accent px-5 font-mono text-xs uppercase tracking-[0.2em] text-accent-foreground hover:bg-accent/90">
                Request a connector <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </PageShell>
  );
}
